<template>
  <lu-vbox lu-flex class="app-container">

    <lu-item>
    <PageHeader :title='$t("Broker Enviroments")' :hasReload='true' :hasDownLoad='true' @reload='reload'/>
    </lu-item>

    <lu-vbox class="searchBox">
      <lu-hbox class='searchDivTitle pad-in-5' lu-vcenter lu-click @click='searchExpanded=!searchExpanded'>
        <lu-item lu-click class="el-icon-arrow-right blc-icon" style='font-size:0.85rem;' :class='searchExpanded ? "isActive" : ""'  />
        <lu-item>{{ $t('search.search') }} </lu-item>
      </lu-hbox>

      <template v-if='searchExpanded'>
        <el-form :model='formQuery' ref="formQuery" label-width="150px">
          <lu-hbox lu-flex-wrap style='justify-content: end'>
            <el-form-item :label="$t('search.label')" prop="brokerShortName" class='mar-r-20'>
              <el-input :placeholder="$t('search.label')" v-model="formQuery.brokerShortName" clearable @keyup.enter.native="search"/>
            </el-form-item>

            <el-form-item :label="$t('Price address')" prop="bpiPriceAddress" class='mar-r-20'>
              <el-input :placeholder="$t('Price address')" v-model="formQuery.bpiPriceAddress" clearable @keyup.enter.native="search"/>
            </el-form-item>

            <el-form-item :label="$t('Trade address')" prop="bpiTradeAddress" class='mar-r-20'>
              <el-input :placeholder="$t('Trade address')" v-model="formQuery.bpiTradeAddress" clearable @keyup.enter.native="search"/>
            </el-form-item>
          </lu-hbox>
        </el-form>

        <lu-hbox lu-hcenter class='pad-in-5 mar-t-10 mar-b-10'>
          <lu-item><el-button icon="el-icon-search" @click="handleSearch('formQuery')">{{ $t('action.search') | upperCase }}</el-button></lu-item>
          <lu-item><el-button icon="el-icon-close"  @click="handleCancel('formQuery')">{{ $t('action.cancel') | upperCase }}</el-button></lu-item>
          <lu-item><el-button icon="el-icon-edit"   v-permission='["adminBrokerEdit"]' @click="handleCreate('formQuery')">{{ $t('action.create')| upperCase }}</el-button></lu-item>
          <lu-item><el-button :loading="downloadLoading" icon="el-icon-download" @click="handleDownload">{{ $t('Export Excel') }}</el-button></lu-item>
        </lu-hbox>
      </template>
    </lu-vbox>

    <!-- <eltable border : set border -->
<!--<el-scrollbar wrap-class="scrollbar-wrapper">-->
  <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
    <el-table
      v-loading="listLoading"
      class='table'
      default-expand-all
      :data="dataTree"
      fit
      striped
      highlight-current-row
      style="width: 100%;"
      row-key="id"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >


      <!-- <el-table-column :label="$t('table.id')" sortable prop="brokerPtfId"  align="center" width="65">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column> -->

      <el-table-column :label="$t('Name')" sortable prop='brokerShortName' align="left">
        <template slot-scope="scope">
          <span>{{ scope.row.brokerShortName }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Platform Name')" sortable prop='brokerPtfName' align="left">
        <template slot-scope="scope">
          <span>{{ scope.row.brokerPtfName }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Status')" sortable prop='status' align='center' >
        <template slot-scope="scope">
            <el-tag style='width:100px;' size="mini" :type="scope.row.status | statusFilter" >
              <i :class="statusActiveName(scope.row.status)" style='margin-right: 5px;' />
                {{ scope.row.status | statusLabel }}
            </el-tag>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Create User')" sortable prop='createUserName' align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createUserName }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Price address')" sortable prop='bpiPriceAddress' align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.bpiPriceAddress }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Trade address')" sortable prop='bpiTradeAddress' align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.bpiTradeAddress }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Actions')" align="center" width="150">
        <template slot-scope="scope">
          <lu-hbox lsu-hcenter slu-vcenter cslass='pad-in-5'>
            <el-button size="mini" class='icon' :icon="$acl.isAllowed('adminBrokerEdit') ? 'el-icon-edit success' : 'el-icon-view success'"  @click='handleEdit(scope.row)'/>
            <el-button size="mini" class='icon' icon="el-icon-delete error"  @click='handleDelete(scope.row)' v-if='$acl.isAllowed("adminBrokerEdit") && scope.row.isUsed === 0'/>
          </lu-hbox>
        </template>
      </el-table-column>
    </el-table>

  </lu-scroll-area>

    <pagination v-show="totalCount>0" :total="totalCount" :page="currentPage" :limit="pageSize"
      :hasDelete='multipleSelection.length>0'
      @deleteSelectedItem="deleteSelectedItem"
      @pagination="getPageFromPagination" />

  </lu-vbox>
</template>

<script>
import BaseController from '@/controllers/BaseController'
import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import { parseTime } from '@/utils'
import Pagination from '@/components/Pagination'
import PageHeader from '@/components/PageHeader'
import { mapGetters } from 'vuex'
import brokerMixin from './mixin'

export default {
  name: 'adminBroker',
  extends: BaseController,
  mixins: [ brokerMixin ],
  components: { Pagination, PageHeader, LuVbox, LuHbox, LuItem, LuScrollArea },
  filters: {
    statusLabel(status) {
      return status === 1 ? 'Active' : 'Inactive'
    },
    statusFilter(status) {
      return status === 1 ? 'success' : 'warning'
    },
    upperCase(str) {
      return str.toUpperCase()
    }
  },
  computed : {
    ...mapGetters( ['pageSize'] ),
    dataTree () {
      let hash = {}
      let arr = []
      this.dataList.forEach(item => {
        if (!hash[item.brokerId]) {
          arr.push({
            id: '' + item.brokerId,
            brokerId: item.brokerId,
            brokerShortName: item.brokerShortName,
            brokerName: item.brokerShortName,
            status: item.brokerStatus,
            createUserName: item.createUserName,
            isUsed: item.isUsed,
            children: []
          })
          hash[item.brokerId] = arr.length
        }
        if (item.brokerPtfId) {
          let idx = hash[item.brokerId] - 1
          arr[idx].children.push(Object.assign({
            id: '' + item.brokerId + '_' + item.brokerPtfId,
            brokerPtfId: item.brokerPtfId,
            brokerId: item.brokerId,
            brokerShortName: item.brokerPtfName,
            brokerName: item.brokerShortName,
            status: item.status,
            isUsed: item.isUsed
          }, item))
          arr[idx].isUsed = arr[idx].isUsed || item.isUsed
        }
      })
      return arr
    }
  },
  data() {
    return {
      searchExpanded: true,
      dataList: null,
      listLoading: true,
      conditions: [],
      order: '',
      multipleSelection: [],
      downloadLoading: false,
      formQuery: {
        brokerShortName: undefined,
        brokerPtfName: undefined,
        status: undefined,
        bpiPriceAddress: undefined,
        bpiTradeAddress: undefined,
        isUsed: undefined
      }
    }
  },
  created() {
    this.getPage()
  },
  methods: {
    selectableRow (row) {
      return row.isUsed === 0
    },
    deleteSelectedItem () {
      let cond = this.multipleSelection.map(item => {
        return { brokerPtfId: item.brokerPtfId }
      })
      this.handleDelete(cond)
    },
    reload () {
      this.getPage(this.currentPage)
    },
    setCondition() {
      this.conditions = []
      if (this.formQuery.brokerShortName) this.conditions.push({ 'field name': 'brokerShortName', operator: 'like', value: [ '%' + this.formQuery.brokerShortName + '%' ] })
      if (this.formQuery.brokerPtfName) this.conditions.push({ 'field name': 'brokerPtfName', operator: 'like', value: [ '%' + this.formQuery.brokerPtfName + '%' ] })
      if (this.formQuery.status) this.conditions.push({ 'field name': 'status', operator: '=', value: [ this.formQuery.status ] })
      if (this.formQuery.bpiTradeAddress) this.conditions.push({ 'field name': 'bpiTradeAddress', operator: 'like', value: [ '%' + this.formQuery.bpiTradeAddress + '%' ] })
      if (this.formQuery.bpiPriceAddress) this.conditions.push({ 'field name': 'bpiPriceAddress', operator: 'like', value: [ '%' + this.formQuery.bpiPriceAddress + '%' ] })
    },
    getPageFromPagination(val) {
      this.currentPage = val.page
      this.getPage(this.currentPage)
    },
    getPage(page) {
      this.listLoading = true
      this.setCondition()
      this.searchData(
        'searchBroker',
        page,
        this.conditions,
        null,
        { },
        () => {
          return true
        },
        function () {
          this.resultExpanded = true
          this.listLoading = false
        }.bind(this),
        'brokerList',
        this.formQuery
      )
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSearch(formName) {
      if (this.$refs[formName].validate()) {
        this.getPage(1)
      }
    },
    sortChange(data) {
      const { prop, order } = data
      this.order = prop + ' ' + (order === 'ascending' ? 'ASC' : 'DESC')
      this.getPage(this.currentPage)
    },
    handleCancel (formName) {
      this.reset()
      this.conditions = []
      this.$refs[formName].resetFields()
      this.resultExpanded = false
      this.getPage(this.currentPage)
    },
    handleEdit (row) {
      let cond = {
        recordId: row.brokerId,
        recordLabel: row.brokerName,
        brokerPtfId: row.brokerPtfId ? row.brokerPtfId : null
      }
      let { params, meta } = this.$route
      let title = (meta && meta.title) ? meta.title + ':' + row.brokerName : row.brokerName
      let routePage = {
        fullpath: '/admin/broker/edit',
        name: 'adminBrokerEdit',
        meta: meta,
        title: title,
        params: Object.assign(cond, params)
      }

      routePage.params = Object.assign(cond, this.$route.params)
      return this.viewEdit(routePage, false, true, false, this.dataList.map(c => {
        return {
          brokerId: c.brokerId,
          brokerPtfId: c.brokerPtfId ? c.brokerPtfId : null,
          label: c.brokerName
        }
      }))
    },
    handleCreate() {
      let routePage = { fullpath: '/admin/broker/edit', name: 'adminBrokerEdit', params: { } }
      return this.viewEdit(routePage, true, true, false, [])
    },
    statusActiveName (type) {
      if (type === 1) return 'el-icon-success'
      else if (type === 4 || type === 5) return 'el-icon-loading'
      else return 'el-icon-check'
    },
    handleDownload() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['brokerId', 'shortName']
        const filterVal = ['brokerId', 'shortName']
        const list = this.dataList
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    }
  }
}
</script>


<style>

</style>